import { Injectable } from '@angular/core';
import { OrganWsShardStateService } from '../../../../state-management/organization-workspace/organ-ws-shard-state.service';
import { WithOrganWsStateBase } from '../../../../state-management/organization-workspace/with-organ-workspace-state-base';
import { handleApiCallAsync } from '../../../../../utils/general-functions';
import { WorkspaceAssetApiService } from '../../associations/workspace-asset-api.service';
import { AssetType, SingleOrArray } from '../../../../../models/defines';
import {
    IGenerateVideoRequest,
    IMoveAssets,
    IRenameAsset,
    IGenerateImageRequest,
} from '../../../../http-models/asset/asset-http-request-model';
import { IExternalLibraryUpload } from '../../../../shared/utils/asset-utils.service';
import {
    IAssetFolderDeleteCommand,
    IGetAssetsParams,
    IProjectAssetMembershipCommand,
} from '../../associations/workspace-asset-request.types';

@Injectable()
export class WorkspaceAssetApiManagerService extends WithOrganWsStateBase {
    constructor(
        orgWsShareState: OrganWsShardStateService,
        private workspaceAssetApi: WorkspaceAssetApiService
    ) {
        super(orgWsShareState);
    }

    uploadAssetAsync(formData: FormData, folder: string, projectId?: string | null) {
        return this.workspaceAssetApi.upload$(formData, this.wsContext, {
            folder: folder,
            ...(projectId ? { projectId } : {}),
        });
    }
    createFolderAsync(folderName: string) {
        return handleApiCallAsync(this.workspaceAssetApi.createFolder$(this.wsContext, folderName));
    }
    renameFileAssetAsync(data: IRenameAsset) {
        return handleApiCallAsync(this.workspaceAssetApi.renameFileAsset$(this.wsContext, data));
    }
    moveAssetsToFolderAsync(moveAssetPayload: IMoveAssets) {
        return handleApiCallAsync(this.workspaceAssetApi.moveAssetToFolder$(this.wsContext, moveAssetPayload));
    }
    getAssetsInWorkspaceAsync(params: IGetAssetsParams) {
        return handleApiCallAsync(this.workspaceAssetApi.getAssetsInWorkspace$(this.wsContext, params));
    }

    getAssetsByIdsAsync(assetIds: SingleOrArray<string>) {
        return handleApiCallAsync(this.workspaceAssetApi.getAssetsByIdsAsync$(this.wsContext, assetIds));
    }

    removeAssetsFromWsAsync(assetIds: SingleOrArray<string>) {
        return this.trashAssetsAsync(assetIds);
    }

    trashAssetsAsync(assetIds: SingleOrArray<string>) {
        return handleApiCallAsync(this.workspaceAssetApi.trashAssets$(this.wsContext, assetIds));
    }

    restoreAssetsAsync(assetIds: SingleOrArray<string>) {
        return handleApiCallAsync(this.workspaceAssetApi.restoreAssets$(this.wsContext, assetIds));
    }

    permanentlyRemoveAssetsAsync(assetIds: SingleOrArray<string>) {
        return handleApiCallAsync(this.workspaceAssetApi.permanentlyRemoveAssets$(this.wsContext, assetIds));
    }

    addAssetsToProjectAsync(command: IProjectAssetMembershipCommand) {
        return handleApiCallAsync(this.workspaceAssetApi.addAssetsToProject$(this.wsContext, command));
    }

    removeFromProjectAsync(projectId: string, assetIds: string[]) {
        return handleApiCallAsync(this.workspaceAssetApi.removeAssetsFromProject$(this.wsContext, { projectId, assetIds }));
    }

    renameFolderAsync(assetId: string, newName: string) {
        return handleApiCallAsync(this.workspaceAssetApi.renameFolder$(this.wsContext, assetId, newName));
    }

    deleteFolderAsync(assetId: string, command: IAssetFolderDeleteCommand) {
        return handleApiCallAsync(this.workspaceAssetApi.deleteFolder$(this.wsContext, assetId, command));
    }

    uploadPhotoFromPhotoLibraryAsync(data: IExternalLibraryUpload, toFolder: string) {
        return handleApiCallAsync(this.workspaceAssetApi.uploadPhotoFromPhotoLibrary$(this.wsContext, data, toFolder));
    }

    generateVideoAsync(data: IGenerateVideoRequest) {
        return handleApiCallAsync(this.workspaceAssetApi.generateVideo$(this.wsContext, data));
    }

    generateImageAsync(data: IGenerateImageRequest) {
        return handleApiCallAsync(this.workspaceAssetApi.generateImage$(this.wsContext, data));
    }
}
